/* Vuex mutations types for module App */

export const TOGGLE_PENDING_STORE_ACTIONS = 'TOGGLE_PENDING_STORE_ACTIONS';



// WEBPACK FOOTER //
// ./src/store/modules/App/mutations-types.js